export default {
  SHOW_VALIDATE: 'SHOW_VALIDATE',
  CLEAR_VALIDATE: 'CLEAR_VALIDATE',
  CLOSE_MODAL_STATUS: 'CLOSE_MODAL_STATUS',
  OPEN_MODAL_STATUS: 'OPEN_MODAL_STATUS',
  OPEN_MODAL_CONFIRM: 'OPEN_MODAL_CONFIRM',
  CLOSE_MODAL_CONFIRM: 'CLOSE_MODAL_CONFIRM',
  OPEN_MODAL_CREATE: 'OPEN_MODAL_CREATE',
  CLOSE_MODAL_CREATE: 'CLOSE_MODAL_CREATE',
  CLEAR_DATA_MODAL: 'CLEAR_DATA_MODAL',
  SHOW_DATE_PICKER: 'SHOW_DATE_PICKER',
  HIDE_DATE_PICKER: 'HIDE_DATE_PICKER',
  SHOW_TIME_PICKER: 'SHOW_TIME_PICKER',
  HIDE_TIME_PICKER: 'HIDE_TIME_PICKER',
  OPEN_CRASH_MEETING_MODAL: 'OPEN_CRASH_MEETING_MODAL',
  CLOSE_CRASH_MEETING_MODAL: 'CLOSE_CRASH_MEETING_MODAL',
  OPEN_BOOKING_DETAIL_MODAL: 'OPEN_BOOKING_DETAIL_MODAL',
  CLOSE_BOOKING_DETAIL_MODAL: 'CLOSE_BOOKING_DETAIL_MODAL',
  OPEN_BOOKING_MORE_DETAIL_MODAL: 'OPEN_BOOKING_MORE_DETAIL_MODAL',
  CLOSE_BOOKING_MORE_DETAIL_MODAL: 'CLOSE_BOOKING_MORE_DETAIL_MODAL',
  OPEN_MODAL_CRASH_BOOKING: 'OPEN_MODAL_CRASH_BOOKING',
  CLOSE_MODAL_CRASH_BOOKING: 'CLOSE_MODAL_CRASH_BOOKING',
  OPEN_MODAL_INFORMATION: 'OPEN_MODAL_INFORMATION',
  CLOSE_MODAL_INFORMATION: 'CLOSE_MODAL_INFORMATION',

  // ORDER MODAL
  SET_ORDER_COUNTER_MODAL: 'SET_ORDER_COUNTER_MODAL',
  SET_CONFIRM_ORDER_MODAL: 'SET_CONFIRM_ORDER_MODAL',
  SET_SUCCESS_ORDER_MODAL: 'SET_SUCCESS_ORDER_MODAL',
  SET_CANCEL_ORDER_MODAL: 'SET_CANCEL_ORDER_MODAL',
  SET_ERROR_ORDER_MODAL: 'SET_ERROR_ORDER_MODAL',
  SET_ISSUE_REPORT_MODAL: 'SET_ISSUE_REPORT_MODAL',
  SET_ISSUE_FILE_LIMIT_MODAL: 'SET_ISSUE_FILE_LIMIT_MODAL',

  // EXTEND MEETING
  OPEN_EXTEND_MEETING_MODAL: 'OPEN_EXTEND_MEETING_MODAL',
  CLOSE_EXTEND_MEETING_MODAL: 'CLOSE_EXTEND_MEETING_MODAL',

  SET_ERROR_MODAL: 'SET_ERROR_MODAL',
}
